module.exports = __webpack_public_path__ + "static/media/Outfit_100Thin.da53e27e.ttf";